/* eslint-disable no-use-before-define */
import React from 'react';
import Comments from '../Elements/Comments';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../Helpers/JsxHelper';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import LogComponent from '../Elements/LogComponent';
import AddressAdmin from '../Contents/Sales/AddressAdmin/AddressAdmin';
import SurveyAdmin from '../Contents/Sales/ClientAdmin/SurveyAdmin/SurveyAdmin';
import dateTimeHelper from '../Helpers/datetimeHelper';
import ContactComponent from '../Contents/Sales/ContactAdmin/ContactComponent';
import LocationsAdmin from '../Contents/Operations/Locations/LocationsAdmin';
import ProjectComponent from '../Contents/Operations/Projects/ProjectComponent';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import OpportunityAdmin from '../Contents/Sales/OpportunityAdmin/OpportunityAdmin';
import FigmaBadge from '../Elements/FigmaBadge';
import FinalizedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/FinalizedAssignmentsList';
import UninvoiceableAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/UninvoiceableAssignmentsList';
import ExcludedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/ExcludedAssignmentsList';
import AllAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/AllAssignmentsList';
import TabbedPage from '../Elements/TabbedPage';
import urlHelper from '../Helpers/urlHelper';
import LongText from '../Elements/LongText';
import ClientAdmin from '../Contents/Sales/ClientAdmin/ClientAdmin';
import userHelper from '../Helpers/userHelper';
import TpClientLinkAdmin from '../Contents/ThirdParty/TpClientLink/TpClientLinkAdmin';
import ErrorMessage from '../Elements/ErrorMessage';
import ShowNameComponent from '../Elements/ShowNameComponent';
import ClientService from '../Services/clientService';

export default class TpClientLinkItem {
  constructor(item) {
    if (item === undefined) {
      this.TpClientLinkId = '';
      this.BravoClientId = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.ThirdPartyClientId = '';
      this.ThirdPartyClientName = '';
      this.ThirdPartySource = '';
      this.CreatedByUserName = '';
      this.ModifiedByUserName = '';
      return;
    }
    this.TpClientLinkId = item.tpClientLinkId;
    this.BravoClientId = item.caspianClientId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOnUtc;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOnUtc;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.ThirdPartyClientName = item.thirdPartyClientName;
    this.ThirdPartySource = item.thirdPartySource;
    this.CreatedByUserName = item.createdByUserName;
    this.ModifiedByUserName = item.modifiedByUserName;
  }

  static NameOfTheIdField() {
    return 'TpClientLinkId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOn', 'ModifiedOn'];
  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    return item.ThirdPartyClientName;
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      // The link's own id first, then the Bravo side of the link, then the third-party side, so the
      // two systems' identifiers read as pairs instead of interleaving. Modified On/By are in the
      // details tab rather than the grid — they say nothing about which link a row is.
      // orderById values are backend sort keys (TpClientLinkRepository.Ordering), so they use the
      // model's Caspian* naming even where the displayed item field is BravoClientId.
      {
        label: 'TP Client Link Id',
        orderById: 'TpClientLinkId',
        data: 'TpClientLinkId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Bravo Client Id',
        orderById: 'CaspianClientId',
        data: 'BravoClientId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Bravo Client Name',
        orderById: 'CaspianClientName',
        // Resolved per row from the id; ShowNameComponent shares one request per distinct client.
        // A link with no Bravo client is the state the standalone page exists to surface, so it is
        // labelled rather than left blank.
        data: (item) => TpClientLinkItem.getBravoClientCellContent(item),
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Third-Party Client Id',
        orderById: 'ThirdPartyClientId',
        data: 'ThirdPartyClientId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Third-Party Client Name',
        orderById: 'ThirdPartyClientName',
        data: (item) => (
          <LongText
            text={item.ThirdPartyClientName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
      {
        label: 'Actions',
        orderById: '',
        data: TpClientLinkItem.getActionsCellContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "TpClientLinkId", label: "TP Client Link Id", className: "text-left" },
        { name: "BravoClientId", label: "Bravo Client Id", className: "text-left" },
        { name: TpClientLinkItem.getBravoClientCellContent, label: "Bravo Client Name", className: "text-left" },
        { name: "ThirdPartyClientId", label: "Third-Party Client Id", className: "text-left" },
        { name: "ThirdPartyClientName", label: "Third-Party Client Name", className: "text-left" },
        { name: "ThirdPartySource", label: "Source", className: "text-left" },
        { name: "ModifiedOn", label: "Modified On", className: "text-left" },
        { name: "ModifiedByUserName", label: "Modified By", className: "text-left", },
        { name: "CreatedOn", label: "Created On", className: "text-left" },
        { name: "CreatedByUserName", label: "Created By", className: "text-left", },
      ],
    },
  ];

  // Set by TpClientLinkAdmin: true on the standalone menu page, false when embedded in a client.
  static isStandalone = false;

  static getBravoClientCellContent(item) {
    if (!item.BravoClientId) {
      return 'Not linked';
    }
    return (
      <ShowNameComponent
        serviceFunction={ClientService.GetClientNameById}
        id={item.BravoClientId}
      />
    );
  }

  static getActionsCellContent(item) {
    const options = [];

    // Unlinking acts on the parent client, so it only exists in the embedded view.
    if (!TpClientLinkItem.isStandalone) {
      options.push({
        text: 'Unlink from Client',
        onClick: () => TpClientLinkItem.unlinkFunction(item.TpClientLinkId, item),
        iconName: 'fa-solid fa-xmark',
        roleKey: 'tpclientlink_unlink',
      });
    }

    options.push({
      text: 'Third-Party Locations',
      iconName: 'fa-solid fa-credit-card',
      url: `/tplocation/search?ThirdPartyClientId=${item.ThirdPartyClientId}`,
      title: 'Third-Party Locations',
      disabled: false,
    });

    return <DataTableActionMenu options={options} />;
  }

  static unlinkFunction = (id, item) => {
    ErrorMessage.SetApprove(
      <span>
        You will unlink this third-party client: {item.ThirdPartyClientName} <br />
        Are you sure?
      </span>,
      () => this.clickOnUnlinkApproved(item.TpClientLinkId)
    );
  };

  static clickOnUnlinkApproved = (thirdPartyClientId) => {
    alert(`It is just a placeholder. Actual implementation will be done in the TpClientLinkAdmin.js file.`);
  };
}
